export default axios => ({
  index(id, payload) {
    return axios.get(`projects/${id}/complete-statistics`, payload);
  }
})
